// e.g., in src/utils/formatting.js or similar
export const toProperCase = (str) => {
  if (!str) return "";
  return str
    .toLowerCase()
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
};
